import { render, staticRenderFns } from "./BlogLink.vue?vue&type=template&id=3e58c468"
import script from "./BlogLink.vue?vue&type=script&lang=ts"
export * from "./BlogLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports